import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcompanharServicoComponent } from './acompanhar-servico/acompanhar-servico.component';
import { BuscaJudicialComponent } from './busca-judicial/busca-judicial.component';
import { CredenciamentoCaminhaoLimpaFossaComponent } from './credenciamento-caminhao-limpa-fossa/credenciamento-caminhao-limpa-fossa.component';
import { CredenciamentoImobiliariasComponent } from './credenciamento-imobiliarias/credenciamento-imobiliarias.component';
import { PesquisaServicoConcluidaComponent } from './pesquisa-servico-concluida/pesquisa-servico-concluida.component';
import { PesquisaServicoErrorComponent } from './pesquisa-servico-error/pesquisa-servico-error.component';
import { PesquisaServicoComponent } from './pesquisa-servico/pesquisa-servico.component';
import { SolicitarServicoComponent } from './solicitar-servico/solicitar-servico.component';

const routes: Routes = [
    {
        path: 'acompanhar',
        component: AcompanharServicoComponent,
    },
    {
        path: 'acompanhar/:id/:ano',
        component: AcompanharServicoComponent,
    },
    {
        path: 'credenciamento-caminhoes-limpa-fossa',
        component: CredenciamentoCaminhaoLimpaFossaComponent,
    },
    {
        path: 'credenciamento-imobiliarias',
        component: CredenciamentoImobiliariasComponent,
    },
    { path: 'busca-judicial', component: BuscaJudicialComponent },
    { path: ':slug', component: SolicitarServicoComponent },
    { path: 'pesquisa/:id/:hash', component: PesquisaServicoComponent },
    {
        path: 'pesquisa/:id/:ano/concluida',
        component: PesquisaServicoConcluidaComponent,
    },
    {
        path: 'pesquisa/error',
        component: PesquisaServicoErrorComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServicosRoutingModule { }
